import { useEffect, useState } from "react";
import { BsInfoCircle } from "react-icons/bs";
import { FiUpload } from "react-icons/fi";
import { useParams } from "react-router-dom";
import WebService from "../../../../utility/WebService";
import { useForm } from "react-hook-form";
import SucessModal from "../../../../components/SucessModal/Sucess";
import WarningModal from "../../../../components/Warning/Warning";
import loader from "../../../../assets/images/button-loader.svg";
import toast from "../../../../components/AppModal/AppModal";
import { useMenuBack } from "../../../../hooks/useMenuBack";
// @ts-ignore — reuse the Agreement module's scoped design language (.aagr-)
import "./AddAgreement.css";

/* ---- small inline field icons (kept local to this screen, matches AddAgreement) ---- */
const IconBack = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7" /></svg>
);
const IconError = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9" /><path d="M12 8v4m0 4h.01" /></svg>
);
const IconDoc = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M14 3H7a2 2 0 00-2 2v14a2 2 0 002 2h10a2 2 0 002-2V8z" /><path d="M14 3v5h5M9 13h6M9 17h6" /></svg>
);
const IconUploadCloud = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M16 16l-4-4-4 4M12 12v9" /><path d="M20.4 15A5 5 0 0018 6.5 6.5 6.5 0 005.5 9 4.5 4.5 0 006 18h1" /></svg>
);

const AgreementUploadDocument = () => {
    const goBack = useMenuBack();
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        formState: { errors },
    } = useForm();
    let { id } = useParams();
    const watchAllFields = watch();
    const [isLoading, setLoading] = useState(false);
    const [sucessMessage, setSucessMessage] = useState<any>();
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const [warningMessage, setWarningMessage] = useState<any>();
    const [isShowWarningModal, setShowWarningModal] = useState(false);
    const [image, setImage] = useState<any>({});
    const [documentName, setDocumentName] = useState("");
    const user_data = JSON.parse(localStorage.getItem("user_Detail") || "{}");
    const isClient = user_data.is_person === "Client";

    useEffect(() => {
    }, []);

    const onSave = () => {
        if (user_data.is_person == "Client") {
            let fileName = image.name;
            let extension = fileName.split(".").pop();
            if (extension == "png" || extension == "jpg" || extension == "jpeg") {
                var form = new FormData();
                if (id) {
                    form.append("id", id);
                }
                if (image) {
                    form.append("ClientAgreements[signature_document]", image);
                }
                setLoading(true);
                WebService.fileUploadAPI({
                    action: `/v2/ClientAgreements/AddSignature`,
                    body: form,
                })
                    .then((res: any) => {
                        setShowSucessModal(true);
                        setSucessMessage(res.message);
                        goBack();
                    })
                    .catch((e) => {
                        setShowWarningModal(true);
                        setWarningMessage(e.response.data.message);
                        setLoading(false);
                    });
            } else {
                setShowWarningModal(true);
                setWarningMessage("File type must be Image.");
            }
        } else if (user_data.is_person == "Employee") {
            let fileName = image.name;
            let extension = fileName.split(".").pop();
            if (extension == "pdf") {
                var form1 = new FormData();
                if (id) {
                    form1.append("id", id);
                }
                if (image) {
                    form1.append("ClientAgreements[final_agreement]", image);
                }
                setLoading(true);
                WebService.fileUploadAPI({
                    action: `/v2/ClientAgreements/UploadDocument`,
                    body: form1,
                })
                    .then((res: any) => {
                        setShowSucessModal(true);
                        setSucessMessage(res.message);
                        goBack();
                    })
                    .catch((e) => {
                        setShowWarningModal(true);
                        setWarningMessage(e.response.data.message);
                        setLoading(false);
                    });
            } else {
                setShowWarningModal(true);
                setWarningMessage("File type must be PDF.");
            }
        }
    };

    const onLoadImage = (event: any) => {
        const { files } = event.target;
        if (files && files[0]) {
            const fileSize = files[0].size / 1024 / 1024; // size in MB
            if (fileSize > 50) {
                toast.error("File size should not exceed 50 MB");
            } else {
                setDocumentName(files[0].name);
                setValue("document_name", files[0].name);
                setImage(files[0]);
            }
        }
        event.target.value = "";
    };

    const warningCloseModal = () => {
        setShowWarningModal(false);
        setLoading(false);
    };

    const sucessCloseModal = () => {
        setShowSucessModal(false);
        setLoading(false);
    };

    return (
        <>
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />
            <div className="page-content-wraper aagr-page">
                <form onSubmit={handleSubmit(onSave)}>
                    {/* ---------- top bar ---------- */}
                    <div className="aagr-topbar">
                        <div className="aagr-crumb">
                            <button type="button" className="aagr-back" onClick={goBack} title="Back">
                                <IconBack />
                            </button>
                            <div>
                                <h1>Upload Agreement Document</h1>
                                <p>MIS Report · Agreement</p>
                            </div>
                        </div>
                        <div className="aagr-actions">
                            <button type="button" className="btn btn-white" onClick={goBack}>Cancel</button>
                            <button type="submit" className="btn btn-brand">
                                {isLoading && <img src={loader} className="spinner" alt="" />}Save
                            </button>
                        </div>
                    </div>

                    {/* ---------- form card ---------- */}
                    <div className="aagr-card">
                        <div className="aagr-card-head">
                            <div className="aagr-badge">
                                <IconUploadCloud />
                            </div>
                            <div>
                                <h2>{isClient ? "Upload Signature" : "Upload Signed Document"}</h2>
                                <p>
                                    Fields marked <span style={{ color: "var(--aagr-red)" }}>*</span> are required
                                </p>
                            </div>
                        </div>

                        <div className="aagr-fields">
                            <div className={"aagr-field aagr-field-wide" + ((!watchAllFields.document_name && errors.document_name) ? " is-invalid" : "")}>
                                {/* hidden field drives react-hook-form's required validation */}
                                <div className="display-none">
                                    <input
                                        type="text"
                                        id="dummy_input"
                                        className="form-control"
                                        {...register("document_name", { required: true })}
                                    />
                                </div>
                                <label className="aagr-lab">
                                    <IconUploadCloud /> {isClient ? "Upload Signature" : "Upload Signed Document"} <span className="aagr-req">*</span>
                                </label>
                                <div className="aagr-upload">
                                    <label className="aagr-upload-btn">
                                        <FiUpload size={18} />
                                        <span>{isClient ? "Upload Signature" : "Upload Document"}</span>
                                        <input
                                            type="file"
                                            title=""
                                            onChange={(e: any) => {
                                                onLoadImage(e);
                                            }}
                                        />
                                    </label>
                                    {documentName && <span className="aagr-file-chip"><IconDoc /> {documentName}</span>}
                                    <BsInfoCircle
                                        className="aagr-upload-info"
                                        title={isClient
                                            ? "Signature must be an image (png, jpg, jpeg). Max size 50 MB."
                                            : "Signed document must be a PDF. Max size 50 MB."}
                                    />
                                </div>
                                {!watchAllFields.document_name && errors.document_name && (
                                    <p className="aagr-err">
                                        <IconError /> {isClient ? "Please Upload Signature" : "Please Upload Document"}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};
export default AgreementUploadDocument;
